<script>

  import { ethers  } from "ethers";
  import { onMount } from "svelte";

  import Contract from "./Recarga.sol/Recarga.json";

  const urlParams = new URLSearchParams(window.location.search);

  const buy_order = urlParams.get("buy_order");
 
  const ethereum = window.ethereum;

  let chainId, chain, provider, signer;

  let data = {
        cryptoAddress: undefined,    
        cryptoFono: undefined,
        loading: false,
    };

  //variables del contrato Recarga
  let contract, contractWithSigner;

  let CONTRACT_ID;
  let ALECTRICO_ETH;
  let maxTokens = 0;
  let currentMinted = 0;
  let ownedTokens = [];
  let recentlyMintedTokens = [];

  let fono = "";
  let account = null;
  let minted = false;
  let transferred = false;
  let loading = false;

  
  //let server_url= "http://www.alectrico.d:5000";

  let server_url= "https://www.alectrico.cl";
  let redeemed = false;
  let withdrawed = false;
  let owner_account = null;
  let owner_logged_in = false;
  let sale_started = false;

  onMount(() => {
    chain = window.ethereum.networkVersion;
  });

  if (ethereum) {
    if (chainId === "1" || chainId == null) {
      CONTRACT_ID= "0xC3D2351f4a2e14cbf86Ab816B1e39dfEB61EC8C6";
      ALECTRICO_ETH= "0xf9f84a5b6889273890ef18C2694eEd446320aec6"
    };
    if ( chainId === "1337")  {
      CONTRACT_ID= "0x5fbdb2315678afecb367f032d93f642f64180aa3";
      ALECTRICO_ETH= "0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266"
    };
    provider = new ethers.providers.Web3Provider(ethereum);
    signer = provider.getSigner();
    contract = new ethers.Contract(CONTRACT_ID, Contract.abi, provider);
    contractWithSigner = contract.connect(signer);
  }

    
  async function init() {
    if (!account && ethereum.selectedAddress) {
      account = ethereum.selectedAddress;
    }

  }


  async function login() {

    loading = true;
    const accounts = await ethereum.request({
      method: "eth_requestAccounts",
    });
    account = accounts[0];

    data.loading = true;
    await fetch(server_url + "/get_suscriptor_ether.json?ether_account=" + account )
     .then((response) => response.json())
     .then((cryptoAccount) => {
        console.log( cryptoAccount );
        data.cryptoAddress = cryptoAccount.address;
        data.cryptoFono    = cryptoAccount.fono;
        fono               = cryptoAccount.fono;
     }
    );
    data.loading = false;

    loading = false;

    init();
 
  }


  async function transfer() {

     const tx = signer.sendTransaction({
       to: CONTRACT_ID,
       value: ethers.utils.parseEther("0.007")
     });

    loading = true;
    transferred = false;

    contractWithSigner.on("LogDepositReceived", ( from, event) => {
      console.log("LogDepositReceived");

        let transferEvent ={
            from: from,
            eventData: event,
        }

        let transferEvent_json = JSON.stringify(transferEvent);
        console.log(transferEvent_json);

        let transaction_hash = transferEvent.eventData.transactionHash ;
 
 
        loading = false;
        transferred = true;

        const body = {
          create_user: {
            cookie: '',
            orden_json: '',
            pago_url: '',
            token_ws: fono,
            nombre: "",
            email: "#{fono}.alectrico.cl",
            fono: fono,
            comuna: "Providencia",
            descripcion: "",
            direccion: "",
            latitude: 0,
            longitude: 0,
            avisar: true,
            address: account,
          }
        };

        const options = {
          body: "",
          method: "GET",
          headers: {
           "Content-Type": "application/json;charset=UTF-8"
          }};

        const request = {
            method: (options.method || "GET"),
            headers: (options.headers || {}),
            body: (options.body || undefined),
            mode: "no-cors",
            cache: "no-cache",
            credentials: "same-origin",
            redirect: "follow",
            referrer: "client", // no-referrer, *client
        };

        fetch(server_url + "/return_ether.json?transaction_hash=" + transaction_hash  + "&buy_order=" + buy_order + "&amount=0.007&ether_account=" + account + "&fono=" + fono , request);


    });

  }

  async function subscribe() {
    //Este body está superdimensionado
    //se usa solamente address y fono
    const body = {
      create_user: {
        cookie: '',
         orden_json: '',
         pago_url: '',
         token_ws: fono,
         nombre: "",
         email: "#{fono}.alectrico.cl",
         fono: fono,
         comuna: "Providencia",
         descripcion: "",
         direccion: "",
         latitude: 0,
         longitude: 0,
         avisar: true,
         address: account,
       }
    };

    console.log(JSON.stringify(body));


    const options = {
      body: JSON.stringify(body),
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      }};
    
     const request = {
            method: (options.method || "GET"),
            headers: (options.headers || {}),
            body: (options.body || undefined),
            mode: "no-cors",
            cache: "no-cache",
            credentials: "same-origin",
            redirect: "follow",
            referrer: "client", // no-referrer, *client
        };
     console.log( request );
     const response = await fetch(server_url + "/create_suscriptor_ether.json?ether_account=" + account + "&fono=" + fono , request);

  }

</script>


<header>
  <link rel="stylesheet" href="assets/bootstrap/css/bootstrap-reboot.min.css">


<section class="header1 cid-sewsPSgeos mbr-parallax-background" id="header1-1">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-11">
        <h1 class="mbr-section-title mbr-fonts-style mb-3 display-4"><strong><em>Electricistas a Domicilio </em></strong><br><strong><em>- en Providencia -</em></strong></h1>
        <h2 class="mbr-section-subtitle mbr-fonts-style mb-3 display-5">
        Misión: Ayudar a proteger la vida y la propiedad</h2>
          {#if  (chain === "1337")}
	    <div class="warning">
	      Por favor, conéctese a la red Principal de Ethereum, conocida como Mainnet.
	    </div>
	  {/if}

	  {#if  chain === "1"}
	    <div class="warning">
	      Conectado a Mainnet.
	    </div>
	  {/if}

	  {#if  chain == null}
	    <div class="danger">
	    </div>
	  {/if}

	  <br><br>
	  {#if ethereum}
	    {#if account}
	      {#if loading}
	      <a class="btn btn-primary-outline display-4" ><span class="mbri-clock mbr-iconfont mbr-iconfont-btn" style="font-size: 44px;"></span><br><br></a>
	      {/if}
	       <div class="btn btn-primary-outline display-4" >
		<form on:submit|preventDefault={subscribe}>
		 <input class=" display-4 " style="font-size: 20px;"
		   type="phone"
		   min= "9"
		   placeholder="¿Ingrese su Fono?"
		   bind:value={fono}
		 />
		 <br><br><br><br> 
		 <button class="btn btn-primary display-4" type="submit">
	<span class="mobi-mbri mobi-mbri-phone mbr-iconfont mbr-iconfont-btn" style="font-size: 144px;">
	</span> Presione Aquí</button>
	       </form>
	      </div>
	      <br><br><br><br>
	       <div class="mbr-section-btn mt-3">
                 <div style="width:10%">
                  <img src= "./assets/images/token_bat.jpg"/>
                 </div>
		 <form on:submit|preventDefault={transfer}>
		  <button class= "btn btn-primary display-4" type="submit">
	<span class="mbri-cash mbr-iconfont mbr-iconfont-btn" style="font-size: 144px;">
	</span> 0.007 ETHER </button>
		 </form>
	      </div>
	      <br><br>
	      <h2 class="mbr-section-subtitle mbr-fonts-style mb-3 display-5">
	      👋 Hola, si gusta, puede comprar esta batería que solo cuesta 0.007 ETHER y que sirve para una visita. Es importante que deje bien anotado su teléfono y que sea el mismo que tenga en alectrico.</h2>

	    {:else}
              <div on:click={login} style="width:40%" >
                <span>
<svg  xmlns="http://www.w3.org/2000/svg" xml:space="preserve" id="Layer_1" x="0" y="0" version="1.1" viewBox="0 0 318.6 318.6">
  <style>
    .st1,.st6{fill:#e4761b;stroke:#e4761b;stroke-linecap:round;stroke-linejoin:round}.st6{fill:#f6851b;stroke:#f6851b}
  </style>
  <path fill="#e2761b" stroke="#e2761b" stroke-linecap="round" stroke-linejoin="round" d="m274.1 35.5-99.5 73.9L193 65.8z"/>
  <path d="m44.4 35.5 98.7 74.6-17.5-44.3zm193.9 171.3-26.5 40.6 56.7 15.6 16.3-55.3zm-204.4.9L50.1 263l56.7-15.6-26.5-40.6z" class="st1"/>
  <path d="m103.6 138.2-15.8 23.9 56.3 2.5-2-60.5zm111.3 0-39-34.8-1.3 61.2 56.2-2.5zM106.8 247.4l33.8-16.5-29.2-22.8zm71.1-16.5 33.9 16.5-4.7-39.3z" class="st1"/>
  <path fill="#d7c1b3" stroke="#d7c1b3" stroke-linecap="round" stroke-linejoin="round" d="m211.8 247.4-33.9-16.5 2.7 22.1-.3 9.3zm-105 0 31.5 14.9-.2-9.3 2.5-22.1z"/>
  <path fill="#233447" stroke="#233447" stroke-linecap="round" stroke-linejoin="round" d="m138.8 193.5-28.2-8.3 19.9-9.1zm40.9 0 8.3-17.4 20 9.1z"/>
  <path fill="#cd6116" stroke="#cd6116" stroke-linecap="round" stroke-linejoin="round" d="m106.8 247.4 4.8-40.6-31.3.9zM207 206.8l4.8 40.6 26.5-39.7zm23.8-44.7-56.2 2.5 5.2 28.9 8.3-17.4 20 9.1zm-120.2 23.1 20-9.1 8.2 17.4 5.3-28.9-56.3-2.5z"/>
  <path fill="#e4751f" stroke="#e4751f" stroke-linecap="round" stroke-linejoin="round" d="m87.8 162.1 23.6 46-.8-22.9zm120.3 23.1-1 22.9 23.7-46zm-64-20.6-5.3 28.9 6.6 34.1 1.5-44.9zm30.5 0-2.7 18 1.2 45 6.7-34.1z"/>
  <path d="m179.8 193.5-6.7 34.1 4.8 3.3 29.2-22.8 1-22.9zm-69.2-8.3.8 22.9 29.2 22.8 4.8-3.3-6.6-34.1z" class="st6"/>
  <path fill="#c0ad9e" stroke="#c0ad9e" stroke-linecap="round" stroke-linejoin="round" d="m180.3 262.3.3-9.3-2.5-2.2h-37.7l-2.3 2.2.2 9.3-31.5-14.9 11 9 22.3 15.5h38.3l22.4-15.5 11-9z"/>
  <path fill="#161616" stroke="#161616" stroke-linecap="round" stroke-linejoin="round" d="m177.9 230.9-4.8-3.3h-27.7l-4.8 3.3-2.5 22.1 2.3-2.2h37.7l2.5 2.2z"/>
  <path fill="#763d16" stroke="#763d16" stroke-linecap="round" stroke-linejoin="round" d="m278.3 114.2 8.5-40.8-12.7-37.9-96.2 71.4 37 31.3 52.3 15.3 11.6-13.5-5-3.6 8-7.3-6.2-4.8 8-6.1zM31.8 73.4l8.5 40.8-5.4 4 8 6.1-6.1 4.8 8 7.3-5 3.6 11.5 13.5 52.3-15.3 37-31.3-96.2-71.4z"/>
  <path d="m267.2 153.5-52.3-15.3 15.9 23.9-23.7 46 31.2-.4h46.5zm-163.6-15.3-52.3 15.3-17.4 54.2h46.4l31.1.4-23.6-46zm71 26.4 3.3-57.7 15.2-41.1h-67.5l15 41.1 3.5 57.7 1.2 18.2.1 44.8h27.7l.2-44.8z" class="st6"/>
</svg>

                </span>
              </div>
                <h2 class="mbr-section-subtitle mbr-fonts-style mb-3 display-5">
                   Presione el logo de Metamask para hacer login con su cuenta. </h2>            	    
            {/if}
	  {:else}
	    <div class="mbr-section-btn mt-3"><a class="btn btn-primary display-4" href="https://wa.me/56945644889"><span class="socicon socicon-whatsapp mbr-iconfont mbr-iconfont-btn"></span></a> <a class="btn btn-info display-4" href="tel:+56962000921"><span class="mobi-mbri mobi-mbri-phone mbr-iconfont mbr-iconfont-btn"></span></a> <a class="btn btn-primary-outline display-4" href="https://alectrico.cl/providencia"><span class="mbri-cart-add mbr-iconfont mbr-iconfont-btn" style="font-size: 44px;"></span><br><br></a></div>
	    <h2 class="mbr-section-subtitle mbr-fonts-style mb-3 display-5">
	     Esta app acepta pagos en ETHER usando MetaMask. </h2>
           {/if}
         </div>
      </div>
  </div>
</section>

</header>


<main>
    <p>buy_order {buy_order}</p>
    {#if data.loading === true}
        Cargando datos desde el Servidor...
    {:else if data.cryptoAddress !== undefined}
      {#if data.cryptoAddress !== null}
        <p>cuenta conectada: {data.cryptoAddress} </p>
      {/if}
    {/if}
</main>

<footer> 
  Las transferencias en la Blockchain no son reembolsables.
</footer>
